
export const MediaFileVI = {
  "MediaFileTitle": {
    "Attach": "Đính kèm",
    "AttachmentType": "Loại đính kèm",
    "ListAttach": "Danh sách file đính kèm",
    "Upload": "Tải lên ",
    "Notify" : "Thông báo",
    "AttachedFile" : "Đính kèm tệp",
    "Operations" : "Thao tác",
    "FileName" : "Tên tệp",
    "TypeFile" : "Thể loại"
  },
  "NotificationMediaFile": {
    "delete" : "Xóa file thành công ... ",
    "question" : "Bạn có chắc muốn xóa file này ? "
  },
  "valueMediaFile": {
    "HD" : "Hợp đồng",
    "TLK" : "Tài liệu khác",
    "LD" : "Lý do ",
    "VB-CC" : "Văn bằng chứng chỉ ",
    "LL" : "Lý lịch"
  }
}
